<template>
  <div>
    <Overlay :overlay="overlay" />
    <v-dialog
      density="compact"
      elevation="0"
      persistent
      transition="dialog-top-transition"
      :model-value="dialogLogoutWarning"
      max-width="400"
    >
      <v-card density="compact" elevation="0" rounded="lg">
        <v-toolbar density="compact" elevation="0" color="primary" rounded="lg">
          <div class="fontVariant1 ml-3">Logout</div>
          <v-spacer></v-spacer>
          <v-icon @click="dialogLogoutWarningEmit(1)" class="mr-2" size="small"
            >mdi-close</v-icon
          >
        </v-toolbar>

        <v-card-text class="pa-2">
          <v-card density="compact" elevation="0">
            <div class="text-center">
              <v-icon color="primary" size="50" class="mt-2"
                >mdi-logout-variant</v-icon
              >
              <div class="fontVariant2">Are you sure want logout ?</div>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                variant="outlined"
                color="primary"
                size="small"
                class="fontVariant1 rounded-lg"
                @click="dialogLogoutWarningEmit(1)"
                >Cancel</v-btn
              >
              <v-btn
                class="fontVariant1 rounded-lg"
                color="primary"
                size="small"
                variant="flat"
                :loading="buttonLoading"
                @click="logoutMethod()"
                >Confirm</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { signOut } from "aws-amplify/auth";
import Overlay from "@/components/Extras/Overlay.vue";
export default {
  props: {
    dialogLogoutWarning: Boolean,
  },
  data() {
    return {
      overlay: false,
      buttonLoading: false,
    };
  },
  components: {
    Overlay,
  },
  methods: {
    async logoutMethod() {
      this.buttonLoading = true;
      try {
        const user = await signOut({
          username: this.$store.getters.get_user_email_id,
        });
        // console.log("User signed in successfully", user);

        if (!user) {
          this.SnackBarComponent = {
            SnackbarVmodel: true,
            SnackbarColor: "green",
            Top: true,
            SnackbarText: "Logout success",
          };
          this.dialogLogoutWarningEmit(2);
        }
      } catch (error) {
        // console.log("Error in  logoutMethod", error);
        this.SnackBarComponent = {
          SnackbarVmodel: true,
          SnackbarColor: "error",
          Top: true,
          SnackbarText: error.message,
        };
      } finally {
        this.buttonLoading = false;
      }
    },
    dialogLogoutWarningEmit(toggle) {
      this.$emit("clicked", toggle);
    },
  },
};
</script>
